/* ==========================================================================
   Section Search Results Page (HMNS Revamp 2026)
   Tab Switching & Filter Drawer JavaScript
   ========================================================================== */

document.addEventListener('DOMContentLoaded', function () {
  const container = document.querySelector('[data-search-page]');
  if (!container) return;

  // 1. Filter & Sort Drawer
  const filterBtn = container.querySelector('[data-filter-drawer-open]');
  const drawer = container.querySelector('[data-filter-drawer]');
  const overlay = container.querySelector('[data-filter-drawer-overlay]');
  const closeBtn = container.querySelector('[data-drawer-close]');
  const form = container.querySelector('#SearchFilterDrawerForm');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.body.classList.add('overflow-hidden');
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    document.body.classList.remove('overflow-hidden');
  }

  if (filterBtn) filterBtn.addEventListener('click', openDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) {
      closeDrawer();
    }
  });

  // 3. Price Slider Synchronization (Dual Handle)
  const priceSlider = container.querySelector('[data-price-slider]');
  if (priceSlider) {
    const rangeMin = priceSlider.querySelector('.collection-price-slider__range--min');
    const rangeMax = priceSlider.querySelector('.collection-price-slider__range--max');
    const inputMin = priceSlider.querySelector('.collection-price-slider__num-input--min');
    const inputMax = priceSlider.querySelector('.collection-price-slider__num-input--max');
    const progress = priceSlider.querySelector('.collection-price-slider__progress');
    const maxLimit = parseInt(priceSlider.getAttribute('data-max-limit'), 10) || 1000000;
    const maxDisplay = priceSlider.querySelector('[data-price-max-display]');

    function formatIDR(val) {
      return new Intl.NumberFormat('id-ID').format(val);
    }

    if (maxDisplay) {
      maxDisplay.textContent = ' ' + formatIDR(maxLimit);
    }

    function updateSliderTrack(syncInputs = false) {
      let minVal = parseInt(rangeMin.value, 10);
      let maxVal = parseInt(rangeMax.value, 10);
      if (isNaN(minVal)) minVal = 0;
      if (isNaN(maxVal)) maxVal = maxLimit;

      if (minVal > maxVal) {
        let tmp = minVal;
        minVal = maxVal;
        maxVal = tmp;
      }

      const percentMin = (minVal / maxLimit) * 100;
      const percentMax = (maxVal / maxLimit) * 100;

      if (progress) {
        progress.style.left = percentMin + '%';
        progress.style.right = 100 - percentMax + '%';
        progress.style.width = 'auto';
      }

      if (syncInputs) {
        if (inputMin && document.activeElement !== inputMin) {
          inputMin.value = minVal === 0 ? '' : minVal;
        }
        if (inputMax && document.activeElement !== inputMax) {
          inputMax.value = maxVal === maxLimit ? '' : maxVal;
        }
      }
    }

    if (rangeMin && rangeMax) {
      rangeMin.addEventListener('input', function () {
        if (parseInt(rangeMin.value, 10) > parseInt(rangeMax.value, 10)) {
          rangeMin.value = rangeMax.value;
        }
        updateSliderTrack(true);
      });

      rangeMax.addEventListener('input', function () {
        if (parseInt(rangeMax.value, 10) < parseInt(rangeMin.value, 10)) {
          rangeMax.value = rangeMin.value;
        }
        updateSliderTrack(true);
      });
    }

    if (inputMin) {
      inputMin.addEventListener('input', function () {
        let val = parseInt(this.value, 10);
        if (isNaN(val)) val = 0;
        if (val > parseInt(rangeMax.value, 10)) val = parseInt(rangeMax.value, 10);
        rangeMin.value = val;
        updateSliderTrack(false);
      });
    }

    if (inputMax) {
      inputMax.addEventListener('input', function () {
        let val = parseInt(this.value, 10);
        if (isNaN(val)) val = maxLimit;
        if (val < parseInt(rangeMin.value, 10)) val = parseInt(rangeMin.value, 10);
        rangeMax.value = val;
        updateSliderTrack(false);
      });
    }

    updateSliderTrack(false);
  }

  // 4. Sort Pills Change auto-submit or apply
  if (form) {
    const sortPills = form.querySelectorAll('input[name="sort_by"]');
    sortPills.forEach(pill => {
      pill.addEventListener('change', function () {
        form.submit();
      });
    });
  }
});
